import type { ISalesCounterpart } from 'models/ISalesCounterpart';

import type {
  SecondaryMarketQuoteRtForm,
  SecondaryMarketQuoteRtFormField,
  SecondaryMarketRtQuoteTabContent,
} from './realtimeQuoteForm.model';

export type SecondaryMarketRealtimeFormActions =
  | SecondaryMarketRtFormFieldChanged
  | SecondaryMarketDealSplitRowCustodianChanged
  | SecondaryMarketDealSplitRowNotionalChanged
  | SecondaryMarketDealSplitRowAdded
  | SecondaryMarketDealSplitRowRemoved
  | SecondaryMarketRtClientSelected
  | SecondaryMarketRtQuoteTabContentPersistRequested
  | SecondaryMarketRtQuoteTabContentPersisted;

/////////////////////////////////////////////

export function secondaryMarketDealSplitRowNotionalChanged(tabId: string, rowIndex: number, notional?: number) {
  return {
    type: 'SECONDARY_MARKET_DEALSPLIT_ROW_NOTIONAL_CHANGED' as const,
    tabId,
    rowIndex,
    notional,
  };
}

export type SecondaryMarketDealSplitRowNotionalChanged = ReturnType<typeof secondaryMarketDealSplitRowNotionalChanged>;

// ////////////////////////////////////
export function secondaryMarketDealSplitRowCustodianChanged(tabId: string, rowIndex: number, custodianId: string) {
  return {
    type: 'SECONDARY_MARKET_DEALSPLIT_ROW_CUSTODIAN_CHANGED' as const,
    tabId,
    rowIndex,
    custodianId,
  };
}
export type SecondaryMarketDealSplitRowCustodianChanged = ReturnType<
  typeof secondaryMarketDealSplitRowCustodianChanged
>;

/////////////////////////////////////////////

export function secondaryMarketDealSplitRowAdded(
  tabId: string,
  custodianId: string | undefined,
  notional: number | undefined,
) {
  return {
    type: 'SECONDARY_MARKET_DEALSPLIT_ROW_ADDED' as const,
    tabId,
    custodianId,
    notional,
  };
}
export type SecondaryMarketDealSplitRowAdded = ReturnType<typeof secondaryMarketDealSplitRowAdded>;
/////////////////////////////////////////////

export function secondaryMarketDealSplitRowRemoved(tabId: string, rowIndex: number) {
  return {
    type: 'SECONDARY_MARKET_DEALSPLIT_ROW_REMOVED' as const,
    tabId,
    rowIndex,
  };
}
export type SecondaryMarketDealSplitRowRemoved = ReturnType<typeof secondaryMarketDealSplitRowRemoved>;

/////////////////////////////////////////////

export function secondaryMarketRtFormClientSelected(tabId: string, client: ISalesCounterpart | undefined) {
  return {
    type: 'SECONDARY_MARKET_RT_CLIENT_SELECTED' as const,
    tabId,
    client,
  };
}
export type SecondaryMarketRtClientSelected = ReturnType<typeof secondaryMarketRtFormClientSelected>;

/////////////////////////////////////////////
export function secondaryMarketRtFormFieldChanged<F extends SecondaryMarketQuoteRtFormField>(
  tabId: string,
  field: F,
  value: SecondaryMarketQuoteRtForm[F],
) {
  return {
    type: 'SECONDARY_MARKET_RT_FORM_FIELD_CHANGED' as const,
    tabId,
    field,
    value,
  };
}
export type SecondaryMarketRtFormFieldChanged = ReturnType<typeof secondaryMarketRtFormFieldChanged>;

export function secondaryMarketRtQuoteTabContentPersistRequested(
  tabId: string,
  tabContent: SecondaryMarketRtQuoteTabContent,
) {
  return {
    type: 'SECONDARY_MARKET_RT_QUOTE_TAB_CONTENT_PERSIST_REQUESTED' as const,
    tabId,
    tabContent,
  };
}
export type SecondaryMarketRtQuoteTabContentPersistRequested = ReturnType<
  typeof secondaryMarketRtQuoteTabContentPersistRequested
>;

/////////////////////////////////////////////

export function secondaryMarketRtQuoteTabContentPersisted(tabId: string, tabContent: SecondaryMarketRtQuoteTabContent) {
  return {
    type: 'SECONDARY_MARKET_RT_QUOTE_TAB_CONTENT_PERSISTED' as const,
    tabId,
    tabContent,
  };
}

export type SecondaryMarketRtQuoteTabContentPersisted = ReturnType<typeof secondaryMarketRtQuoteTabContentPersisted>;
